<!-- <link href="assets/vendor/datatables/dataTables.bootstrap4.min.css" rel="stylesheet"> -->
<div class="container-fluid" >
  <div class="card shadow">
    <div class="card-header d-flex justify-content-between">
      <h4 class="font-weight-bold text-dark py">OFFICE BEARER</h4>
      <div class="col-2" style="margin-left:67%">
          <button type="button" class="btn btn-block btn-danger" data-toggle="modal" data-target="#myModal">Add</button>
      </div>
      
      
  </div>
      

      <div class="modal fade" id="modal-xl">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="card-danger">
                  <div class="card-header">
                    <h3 class="card-title">Edit Office Bearer Information</h3>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                  </div>
                  <div class="card-body">
                    <form [formGroup]='editform' (ngSubmit)="updatedata(editform)" autocomplete="off">
                        <div style="text-align:right"><h6>Assembly constituency/சட்டமன்ற தொகுதி: </h6></div>
                
                      <div class="form-group row">
                              <div class="col-6 md:col-6">
                                <label>First Name/முதல் பெயர்</label>
                                <input type="text" name="firstname1" formControlName="firstname1" class="form-control"  placeholder="Enter First Name/முதல் பெயர்"/>
                              </div>
                              <div class="col-6 md:col-6">
                                <label>Last Name/குடும்ப பெயர்</label>
                                <input type="text" name="lastname1" formControlName="lastname1" class="form-control"  placeholder="Enter Last Name/குடும்ப பெயர்"/>
                              </div>
                      </div>
                      <div class="form-group row">
                            <div class="col-6 md:col-6">
                              <label>Age / வயது</label>
                              <input type="number" name="age1" class="form-control"  min="18" max="100" placeholder="Enter Age / வயது" formControlName="age1" />
                            </div>
                            <div class="col-sm-6">
                              <label>Date of Birth</label>
                              <input type="date" name="date_of_birth1" class="form-control"  placeholder="Enter Date of Birth" formControlName="date_of_birth1"/>
                            </div>
                      </div>
                      <div class="form-group row">
                            <div class="col-6 md:col-6">
                              <label>Father Name / தந்தையின் பெயர்</label>
                              <input type="text" name="father_name1" class="form-control"  placeholder="Enter Father Name / தந்தையின் பெயர்" formControlName="father_name1"/>
                            </div>
                            <div class="col-6 md:col-6">
                              <label>Mother Name / தாய் பெயர்</label>
                              <input type="text" name="mother_name1" class="form-control"  placeholder="Enter Mother Name / தாய் பெயர்" formControlName="mother_name1"/>
                            </div>
                      </div>
                      <div class="form-group row">
                          <div class="col-6 md:col-6">
                            <label>Degree / கல்வித் தகுதி</label>
                            <input type="text" name="educational_qualification1" formControlName="educational_qualification1" class="form-control"  placeholder="Enter Degree / கல்வித் தகுதி"/>
                          </div>
                          <div class="col-6 md:col-6">
                            <label>Additional Degree / சிறப்பு தகுதி</label>
                          <input type="text" name="additional_qualification" formControlName="additional_qualification1" class="form-control"  placeholder="Enter Additional Degree / சிறப்பு தகுதி"/>
                          </div>
                      </div>

                      <div class="form-group row">
                              <div class="col-6 md:col-6">
                                <label>Phone Number / தொலைபேசி எண்</label>
                                <input type="text" name="contact_no1" formControlName="contact_no1" class="form-control"  placeholder="Enter Phone Number / தொலைபேசி எண்" />
                              </div>
                              <div class="col-6 md:col-6">
                                <label>Whatsapp Number /வாட்ஸ்அப் எண்</label>
                                <input type="text" name="whatsapp_no" formControlName="whatsapp_no1" class="form-control"  placeholder="Enter Whatsapp Number /வாட்ஸ்அப் எண்" />
                              </div>
                      </div>
                      <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Email/மின்னஞ்சல்</label>
                              <input type="text" name="email1" formControlName="email1" class="form-control"  placeholder="Enter Email/மின்னஞ்சல்" />
                            </div>
                      </div>
                      <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Profession / தொழில்,வேலை</label>
                              <input pInputText type="text" class="form-control" name="profession1" formControlName="profession1"  placeholder="Enter Profession / தொழில்,வேலை" />
                            </div>
                      </div>
                      <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Address / முகவரி</label>
                              <textarea name="address1" formControlName="address1" pInputText class="form-control"  placeholder="Enter Address / முகவரி" cols="100" rows="5"></textarea>
                            </div>
                      </div>
                      <div class="form-group">
                            <div class="col-12 md:col-12">
                                <label>Responsibility For Applying / விண்ணப்பிப்பதற்கான பொறுப்பு</label><br>
                                <select name="applied_role" formControlName="applied_role1"  class="form-control">
                                    <option value="">Select Option</option>
                                    <option value="Village Deputy Organiser">District President / மாவட்ட தலைவர்</option>
                                    <option value="Village Deputy Organiser">District Vice President / மாவட்ட துணை தலைவர்</option>
                                    <option value="District Organiser">District Organiser / மாவட்ட அமைப்பாளர்</option>
                                    <option value="District Deputy Organiser">District Deputy Organiser / மாவட்ட துணை அமைப்பாளர்</option>
                                    <option value="Union Organiser">Union Organiser / ஒன்றிய அமைப்பாளர்</option>
                                    <option value="Union Deputy Organiser">Union Deputy Organiser / ஒன்றிய துணை அமைப்பாளர்</option>
                                    <option value="City Organiser">City Organiser / நகர அமைப்பாளர்</option>
                                    <option value="City Deputy Organiser">City Deputy Organiser / நகர துணை அமைப்பாளர்</option>
                                    <option value="Area Organiser">Area Organiser / பகுதி அமைப்பாளர்</option>
                                    <option value="Area Deputy Organiser">Area Deputy Organiser / பகுதி துணை அமைப்பாளர்</option>
                                    <option value="Village Organiser">Village Organiser / ஊரக அமைப்பாளர்</option>
                                    <option value="Village Deputy Organiser">Village Deputy Organiser / ஊரக துணை அமைப்பாளர்</option>
                                   
                                </select>
                            </div>
                      </div>
                      <div class="form-group">
                          <div class="col-sm-6">
                            <label>Comments</label>
                            <textarea name="party_comments1" formControlName="party_comments1" pInputText class="form-control"  placeholder="Enter Comments" cols="100" rows="5" ></textarea>
                          </div>
                      </div>
                      <div class="col-3" style="margin-left:34%;">
                          <button  class="btn btn-danger btn btn-block">
                            UPDATE OFFICE BEARER
                          </button>
                        </div>
                      </form>
                  </div>
             </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->

      <div class="modal fade" id="showDialog">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="card-danger">
                  <div class="card-header">
                    <h3 class="card-title">Office Bearer Information (Non-Editable)</h3>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                  </div>
                  <div class="card-body">
                    <form>
                        <div style="text-align:right"><h6>Assembly constituency/சட்டமன்ற தொகுதி: </h6></div>
                
                      <div class="form-group row">
                              <div class="col-6 md:col-6">
                                <label>First Name/முதல் பெயர்</label>
                                <input type="text" class="form-control" [disabled]="true" placeholder="Enter First Name/முதல் பெயர்" [value]="OBname"/>
                              </div>
                              <div class="col-6 md:col-6">
                                <label>Last Name/குடும்ப பெயர்</label>
                                <input type="text" name="lastname" class="form-control" [disabled]="true" placeholder="Enter Last Name/குடும்ப பெயர்" [value]="OBlastname"/>
                              </div>
                      </div>
                      <div class="form-group row">
                            <div class="col-6 md:col-6">
                              <label>Age / வயது</label>
                              <input type="number" name="age" class="form-control" [disabled]="true" min="18" max="100" placeholder="Enter Age / வயது"[value]="OBage"/>
                            </div>
                            <div class="col-sm-6">
                              <label>Date of Birth</label>
                              <input type="date" name="date_of_birth"class="form-control" [disabled]="true" placeholder="Enter Date of Birth"[value]="OBdateofbirth"/>
                            </div>
                      </div>
                      <div class="form-group row">
                            <div class="col-6 md:col-6">
                              <label>Father Name / தந்தையின் பெயர்</label>
                              <input type="text" name="father_name" class="form-control" [disabled]="true" placeholder="Enter Father Name / தந்தையின் பெயர்"[value]="OBfathername"/>
                            </div>
                            <div class="col-6 md:col-6">
                              <label>Mother Name / தாய் பெயர்</label>
                              <input type="text" name="mother_name" class="form-control" [disabled]="true"  placeholder="Enter Mother Name / தாய் பெயர்" formControlName="mother_name"  [value]="OBfathername"/>
                            </div>
                      </div>
                      <div class="form-group row">
                          <div class="col-6 md:col-6">
                            <label>Degree / கல்வித் தகுதி</label>
                            <input type="text" name="educational_qualification" class="form-control" [disabled]="true" placeholder="Enter Degree / கல்வித் தகுதி"[value]="OBdegree"/>
                          </div>
                          <div class="col-6 md:col-6">
                            <label>Additional Degree / சிறப்பு தகுதி</label>
                          <input type="text" name="additional_qualification" class="form-control" [disabled]="true" placeholder="Enter Additional Degree / சிறப்பு தகுதி"[value]="OBaddtionaldegree"/>
                          </div>
                      </div>

                      <div class="form-group row">
                              <div class="col-6 md:col-6">
                                <label>Phone Number / தொலைபேசி எண்</label>
                                <input type="text" name="contact_no" class="form-control" [disabled]="true" placeholder="Enter Phone Number / தொலைபேசி எண்"[value]="OBphonenumber"/>
                              </div>
                              <div class="col-6 md:col-6">
                                <label>Whatsapp Number /வாட்ஸ்அப் எண்</label>
                                <input type="text" name="whatsapp_no" class="form-control" [disabled]="true" placeholder="Enter Whatsapp Number /வாட்ஸ்அப் எண்"[value]="whatsappnumner"/>
                              </div>
                      </div>
                      <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Email/மின்னஞ்சல்</label>
                              <input type="text" name="email" class="form-control" [disabled]="true" placeholder="Enter Email/மின்னஞ்சல்"[value]="OBmail"/>
                            </div>
                      </div>
                      <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Profession / தொழில்,வேலை</label>
                              <input pInputText type="text" class="form-control" name="profession" [disabled]="true" placeholder="Enter Profession / தொழில்,வேலை"[value]="OBprofession"/>
                            </div>
                      </div>
                      <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Address / முகவரி</label>
                              <textarea name="address1" pInputText class="form-control"  [disabled]="true" placeholder="Enter Address / முகவரி" cols="100" rows="5" [value]="OBaddress"></textarea>
                            </div>
                      </div>
                      <div class="form-group">
                            <div class="col-12 md:col-12">
                                <label>Responsibility For Applying / விண்ணப்பிப்பதற்கான பொறுப்பு</label><br>
                                <select name="applied_role"  class="form-control" [disabled]="true" [value]="OBold_designation">
                                    <option value="">Select Option</option>
                                    <option value="District Organiser">District Organiser / மாவட்ட அமைப்பாளர்</option>
                                    <option value="District Deputy Organiser">District Deputy Organiser / மாவட்ட துணை அமைப்பாளர்</option>
                                    <option value="Union Organiser">Union Organiser / ஒன்றிய அமைப்பாளர்</option>
                                    <option value="Union Deputy Organiser">Union Deputy Organiser / ஒன்றிய துணை அமைப்பாளர்</option>
                                    <option value="City Organiser">City Organiser / நகர அமைப்பாளர்</option>
                                    <option value="City Deputy Organiser">City Deputy Organiser / நகர துணை அமைப்பாளர்</option>
                                    <option value="Area Organiser">Area Organiser / பகுதி அமைப்பாளர்</option>
                                    <option value="Area Deputy Organiser">Area Deputy Organiser / பகுதி துணை அமைப்பாளர்</option>
                                    <option value="Village Organiser">Village Organiser / ஊரக அமைப்பாளர்</option>
                                    <option value="Village Deputy Organiser">Village Deputy Organiser / ஊரக துணை அமைப்பாளர்</option>
                                </select>
                            </div>
                      </div>
                      <div class="form-group">
                          <div class="col-sm-6">
                            <label>Comments</label>
                            <textarea name="party_comments" pInputText class="form-control" [disabled]="true" placeholder="Enter Comments" cols="100" rows="5" [value]="OBcomments"></textarea>
                          </div>
                      </div>
                      <!-- <div class="col-3" style="margin-left:34%;">
                          <a  class="btn btn-danger btn btn-block">
                            UPDATE OFFICE BEARER
                          </a>
                        </div> -->
                      </form>
                  </div>
             </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      

      



            <div class="modal fade" id="myModal">
              <div class="modal-dialog modal-xl">
                <div class="modal-content">
                  <div class="card-danger">
                    <div class="card-header">
                      <h3 class="card-title">Create office bearer</h3>
                      <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="card-body">
                      <form  [formGroup]='officebearerform' (ngSubmit)="postdata(officebearerform)" autocomplete="off">
                          <div style="text-align:right"><h6>Assembly constituency/சட்டமன்ற தொகுதி: </h6></div>
                  
                        <div class="form-group row">
                                <div class="col-6 md:col-6">
                                  <label>First Name/முதல் பெயர்</label><span class="required "> *</span>
                                  <input type="text" name="firstname" class="form-control"  placeholder="Enter First Name/முதல் பெயர்" formControlName="firstname"/>
                                  <div  *ngIf="officebearerform.get('firstname').hasError('required') && officebearerform.get('firstname').touched"
                                    class="invalid-msg">Please enter the valid field
                                </div>
                                <div *ngIf="officebearerform.get('firstname').hasError('pattern') && officebearerform.get('firstname').touched"
                                    class="invalid-msg">Please enter the valid Name
                              </div>
                                </div>
                                <div class="col-6 md:col-6">
                                  <label>Last Name/குடும்ப பெயர்</label><span class="required "> *</span>
                                  <input type="text" name="lastname" class="form-control"  placeholder="Enter Last Name/குடும்ப பெயர்" formControlName="lastname"/>
                                  <div *ngIf="officebearerform.get('lastname').hasError('required') && officebearerform.get('lastname').touched"
                                    class="invalid-msg">Please enter the valid field
                                  </div>
                                  <div *ngIf="officebearerform.get('lastname').hasError('pattern') && officebearerform.get('lastname').touched"
                                    class="invalid-msg">Please enter the valid Name
                                  </div>
                                </div>
                        </div>
                        <div class="form-group row">
                              <div class="col-6 md:col-6">
                                <label>Age / வயது</label><span class="required "> *</span>
                                <input type="number" name="age" class="form-control"  min="18" max="100" placeholder="Enter Age / வயது" formControlName="age"/>
                              </div>
                              <div class="col-sm-6">
                                <label>Date of Birth</label><span class="required "> *</span>
                                <input type="date" name="date_of_birth"class="form-control"  placeholder="Enter Date of Birth" formControlName="date_of_birth"/>
                              </div>
                        </div>
                        <div class="form-group row">
                              <div class="col-6 md:col-6">
                                <label>Father Name / தந்தையின் பெயர்</label><span class="required "> *</span>
                                <input type="text" name="father_name" class="form-control"  placeholder="Enter Father Name / தந்தையின் பெயர்" formControlName="father_name"/>
                              </div>
                              <div class="col-6 md:col-6">
                                <label>Mother Name / தாய் பெயர்</label>
                                <input type="text" name="mother_name" class="form-control"  placeholder="Enter Mother Name / தாய் பெயர்" formControlName="mother_name"/>
                              </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-6 md:col-6">
                              <label>Degree / கல்வித் தகுதி</label><span class="required "> *</span>
                              <input type="text" name="educational_qualification" class="form-control"  placeholder="Enter Degree / கல்வித் தகுதி" formControlName="educational_qualification"/>
                            </div>
                            <div class="col-6 md:col-6">
                              <label>Additional Degree / சிறப்பு தகுதி</label>
                            <input type="text" name="additional_qualification" class="form-control"  placeholder="Enter Additional Degree / சிறப்பு தகுதி" formControlName="additional_qualification"/>
                            </div>
                        </div>
                        
                        <div class="form-group row">
                                <div class="col-6 md:col-6">
                                  <label>Phone Number / தொலைபேசி எண்</label><span class="required "> *</span>
                                  <input type="text" name="contact_no" class="form-control"  placeholder="Enter Phone Number / தொலைபேசி எண்" formControlName="contact_no"/>
                                  <div *ngIf="officebearerform.get('contact_no').hasError('required') && officebearerform.get('contact_no').touched"
                                    class="invalid-msg">Please enter the valid field
                                  </div>
                                  <div  *ngIf="officebearerform.get('contact_no').hasError('pattern') && officebearerform.get('contact_no').touched"
                                    class="invalid-msg">Please enter the valid Phone Number
                                  </div>
                                </div>
                                <div class="col-6 md:col-6">
                                  <label>Whatsapp Number /வாட்ஸ்அப் எண்</label><span class="required "> *</span>
                                  <input type="text" name="whatsapp_no" class="form-control"  placeholder="Enter Whatsapp Number /வாட்ஸ்அப் எண்" formControlName="whatsapp_no"/>
                                  <div *ngIf="officebearerform.get('whatsapp_no').hasError('required') && officebearerform.get('whatsapp_no').touched"
                                     class="invalid-msg">Please enter the valid field
                                  </div>
                                  <div *ngIf="officebearerform.get('whatsapp_no').hasError('pattern') && officebearerform.get('whatsapp_no').touched"
                                    class="invalid-msg">Please enter the valid Whatsapp Number
                                  </div>
                                </div>
                        </div>
                        
                        <div class="form-group">
                              <div class="col-6 md:col-6">
                                <label>Email/மின்னஞ்சல்</label><span class="required "> *</span>
                                <input type="text" name="email" class="form-control"  placeholder="Enter Email/மின்னஞ்சல்" formControlName="email"/>
                                 <div *ngIf="officebearerform.get('email').hasError('required') && officebearerform.get('email').touched"
                                   class="invalid-msg">Please enter the valid field
                                  </div>
                                 <div *ngIf="officebearerform.get('email').hasError('pattern') && officebearerform.get('email').touched"
                                  class="invalid-msg">Please enter the valid Email Id
                                </div>
                              </div>
                        </div>
                        <div class="form-group">
                              <div class="col-6 md:col-6">
                                <label>Profession / தொழில்,வேலை</label>
                                <input pInputText type="text" class="form-control" name="profession"  placeholder="Enter Profession / தொழில்,வேலை" formControlName="profession"/>
                              </div>
                        </div>
                        <div class="form-group">
                              <div class="col-6 md:col-6">
                                <label>Address / முகவரி</label>
                                <textarea name="address1" pInputText class="form-control"  placeholder="Enter Address / முகவரி" cols="100" rows="5" formControlName="address1"></textarea>
                              </div>
                        </div>
                        <div class="form-group">
                              <div class="col-12 md:col-12">
                                  <label>Responsibility For Applying / விண்ணப்பிப்பதற்கான பொறுப்பு</label><br>
                                  <select name="applied_role"  class="form-control" formControlName="applied_role">
                                      <option value="">Select Option</option>
                                      <option value="District Organiser">District Organiser / மாவட்ட அமைப்பாளர்</option>
                                      <option value="District Deputy Organiser">District Deputy Organiser / மாவட்ட துணை அமைப்பாளர்</option>
                                      <option value="Union Organiser">Union Organiser / ஒன்றிய அமைப்பாளர்</option>
                                      <option value="Union Deputy Organiser">Union Deputy Organiser / ஒன்றிய துணை அமைப்பாளர்</option>
                                      <option value="City Organiser">City Organiser / நகர அமைப்பாளர்</option>
                                      <option value="City Deputy Organiser">City Deputy Organiser / நகர துணை அமைப்பாளர்</option>
                                      <option value="Area Organiser">Area Organiser / பகுதி அமைப்பாளர்</option>
                                      <option value="Area Deputy Organiser">Area Deputy Organiser / பகுதி துணை அமைப்பாளர்</option>
                                      <option value="Village Organiser">Village Organiser / ஊரக அமைப்பாளர்</option>
                                      <option value="Village Deputy Organiser">Village Deputy Organiser / ஊரக துணை அமைப்பாளர்</option>
                                  </select>
                              </div>
                        </div>
                        <div class="form-group">
                            <div class="col-sm-6">
                              <label>Comments</label>
                              <textarea name="party_comments" pInputText class="form-control"  placeholder="Enter Comments" cols="100" rows="5" formControlName="party_comments"></textarea>
                            </div>
                            <div class="col-6 md:col-6">
                              <input  type="text" hidden  formControlName="mode"/>
                            </div>
                            <div class="col-6 md:col-6">
                              <input type="text" hidden  formControlName="location_id"/>
                            </div>
                        </div>
                        <!-- <div class="form-group">
                            <div class="col-6 md:col-6">
                              <label>Status / நிலை</label>
                              <input pInputText type="text" hidden class="form-control" name="mode" formControlName="mode"/>
                            </div>
                            <div class="col-6 md:col-6">
                              <label>Status / நிலை</label>
                              <input pInputText type="text" hidden class="form-control" name="location_id" formControlName="location_id"/>
                            </div>
                        </div> -->
                          <div class="col-3" style="margin-left:34%;">
                            <button class="btn btn-danger btn btn-block">Create office bearer</button>
                          </div>
                        </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>


<!-- OFFICE BEARER DATATABLE         -->
<div class="card-body">
  <div class="table-responsive">
      <!-- TABLE -->
          <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%" cellspacing="0">
            <thead>
              <tr>
                  <th>Name</th>
                  <!-- <th>Designation</th> -->
                  <!-- <th>Applied role</th> -->
                  <!-- <th>Status</th> -->
                  <th>Email</th>
                  <th>Contact no</th>
                  <th>Request</th>
                  <th>Show</th>
                  <th>Edit</th>
                  <th>Delete</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let customer of customers">
                <td style="min-width: 20px;">
                  {{customer.name}}
                  </td>
                  <!-- <td style="min-width: 20px;">
                  {{customer.designation}}
                  </td> -->
                  <!-- <td style="min-width: 20px;">
                  {{customer.applied_role}}
                  </td> -->
                  <!-- <td style="min-width: 20px;">
                  {{customer.approval_status}}
                  </td> -->
                  <td style="min-width: 20px;">
                  {{customer.email}}
                  </td>
                  <td style="min-width: 20px;">
                    {{customer.contact_no}}
                    </td>
                  <td><a data-toggle="modal" data-target="#requestDialog" class="btn btn-primary btn-circle btn-sm" (click)="editbuttonviewOB(customer)">
                    <i class="fas fa-flag"></i>
                </a></td>
                  <td><a data-toggle="modal" data-target="#showDialog" class="btn btn-primary btn-circle btn-sm" (click)="editbuttonviewOB(customer)">
                      <i class="fas fa-flag"></i>
                  </a></td>
                  <td><a data-toggle="modal" data-target="#modal-xl" class="btn btn-info btn-circle btn-sm" (click)="editbuttonviewOB(customer)">
                      <i class="fas fa-check"></i>
                  </a></td>
                  <td><a  class="btn btn-danger btn-circle btn-sm" (click)="delete_ob(customer.id)">
                      <i class="fas fa-trash"></i>
                  </a></td>
                </tr>
            </tbody>
            
          </table>
  </div>
</div>
  
</div>

</div>

<div class="modal fade" id="requestDialog">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="card-danger">
        <div class="card-header">
          <h3 class="card-title">Request office bearer</h3>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="card-body">

           <form class="request-form" [formGroup]='reqform' autocomplete="off">
            <div class="form-group">
                <div class="col-6 md:col-6">
                  <input type="text" pInputText  hidden name="user_id" formControlName="user_id" [value]="OBid"
                    placeholder="obid" />

                </div>
              </div>
            <div class="form-group">
             <div class="col-12 md:col-12">
                                  <label>First Name</label><span class="required "> *</span>
                                  <input  pInputText type="text" name="name" class="form-control"  placeholder="Enter Name" [value]="OBname+OBlastname" formControlName="name"/>
                                  <div  *ngIf="reqform.get('name').hasError('required') && reqform.get('name').touched"
                                    class="invalid-msg">Please enter the valid field
                                </div>
                </div>
  
            </div>
            <!-- </div> -->
            <div class="form-group">
              <div class="col-12 md:col-12">
                                   <label>Email</label><span class="required "> *</span>
                                   <input  pInputText type="text" name="email1" class="form-control"  placeholder="Email"  formControlName="email1"/>
                                   <div  *ngIf="reqform.get('email1').hasError('email') && reqform.get('email1').touched"
                                     class="invalid-msg">Please enter the valid field
                                 </div>
                 </div>
   
             </div>
            <div class="form-group">
              <div class="col-12 md:col-12">
                                   <label>Old Designation</label><span class="required "> *</span>
                                   <input  pInputText type="text" name="old_designation" class="form-control"  placeholder="Old Designation"  formControlName="old_designation"/>
                                   <!-- <div  *ngIf="reqform.get('old_designation').hasError('old_designation') && reqform.get('old_designation').touched"
                                     class="invalid-msg">Please enter the valid field
                                 </div> -->
                 </div>
   
             </div>
             
            <div class="form-group ">
                <div class="col-12 md:col-12">
                  <label>New Designation</label><span class="required "> *</span>
                    <input pInputText type="text" name="new_designation1"  class="form-control" formControlName="new_designation1" placeholder="New Designation" >
                    <div  *ngIf="reqform.get('new_designation1').hasError('new_designation1') && reqform.get('new_designation1').touched"
                    class="invalid-msg">Please enter the valid field
                  </div>
            </div>
            </div>
            <div class="form-group ">
                <div class="col-12 md:col-12">
                  <label>Reason</label><span class="required "> *</span>
                    <input pInputText type="text" name="reason"  class="form-control" formControlName="reason" placeholder="Reason " >
                    <!-- <div  *ngIf="reqform.get('reason1').hasError('reason1') && reqform.get('reason1').touched"
                    class="invalid-msg">Please enter the valid field
                  </div> -->
                </div>
            </div>
            <div class="col-3" style="margin-left:34%;">
              <button  class="btn btn-danger btn btn-block">
                REQUEST APPLY
              </button>
            </div>
            
            
            
        </form>
        </div>
      </div>
    </div>
  </div>
</div>